import type {
  InstallmentPlanTemplateDTO,
  InstallmentPlanTemplateRowDTO,
} from "../contracts";

export type BuiltInstallment = {
  installmentNo: number;
  label?: string;
  labelEn?: string;
  dueDate: Date;
  amount: number;
};

function addDaysDateOnly(base: Date, offsetDays: number): Date {
  const d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
  d.setDate(d.getDate() + offsetDays);
  return d;
}

export function buildInstallmentsFromTemplate(
  template:
    | Pick<InstallmentPlanTemplateDTO, "rows">
    | { rows: InstallmentPlanTemplateRowDTO[] },
  grandTotal: number,
  issuedAt: Date,
): BuiltInstallment[] {
  const rows = [...template.rows].sort(
    (a, b) => a.installmentNo - b.installmentNo,
  );
  if (rows.length === 0) return [];

  const amounts: number[] = [];
  let allocated = 0;

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i]!;
    if (i === rows.length - 1) {
      amounts.push(grandTotal - allocated);
    } else {
      const amount = Math.round((grandTotal * row.percent) / 100);
      amounts.push(amount);
      allocated += amount;
    }
  }

  return rows.map((row, index) => ({
    installmentNo: row.installmentNo,
    label: row.label ?? undefined,
    labelEn: row.labelEn ?? undefined,
    dueDate: addDaysDateOnly(issuedAt, row.dueOffsetDays),
    amount: amounts[index]!,
  }));
}
